// srt.js

import { initVehicleSection } from './srt-vehicle.js';
import { initTyresSection } from './srt-tyres.js';
import { initPayloadCalculation } from './srt-tare-gross.js';
import { initSuspensionModule, updateTrackWidthDisplay } from './srt-suspension.js';
import { initLoad } from './srt-load.js';
import { renderResults, renderMessageCard, resetSummaryResultCard, showHideResults } from './srt-results.js';
import { enableLiveValidation, validateAllFields } from './srt-validate-form.js';
import { initFileLoader } from './srt-loader.js';
import { initReport } from './srt-report.js';
import { debounce } from '../utils.js';
import {
   refreshCogSRTChart,
   refreshPayloadSRTChart,
   refreshFeasibleBoundaryChart,
   setupGraphsTabListener,
} from './srt-results-charts.js';
import { GLOSSARY } from './srt-glossary-definitions.js';

let currentSRT = 0;
window.currentPayloadCog = 0;
let frontTrackWidth = 0;
let rearTrackWidth = 0;

// document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabEl) => {
//    new Tab(tabEl); // manually attach Bootstrap behavior
// });

$(function () {
   initTargetSRT();
   const unitIdx = 0; // Single unit only for now, some support already in place
   initVehicleSection(); // vehicle accordion init
   //initTyresSection(); // tyre accordion init
   initPayloadCalculation(); // payload calculation in axle load section
   initLoad(); // load accordion init
   initSuspensionModule(unitIdx); // suspension accordion init - also supports units param
   initUnitNav(); // Future support for multiple units
   enableLiveValidation(unitIdx);
   initFileLoader(); // File loader for test cases
   initReport(); // Report generation
   initCharts(unitIdx);

   // Setup the General SRT form change handler - bound to all input fields in the form
   bindSRTFormChangeHandler((input, field, unitIndex) => {
      triggerSRTCalculation(unitIndex);
   }, 1000); // debounce delay before the change handler is called

   // set initial SRT calculation
   triggerSRTCalculation(unitIdx);

   // Bind the refresh graphs button
   const buttonId = `#calculate-curves-${unitIdx}`;
   $(buttonId).on('click', function () {
      refreshSRTCharts(unitIdx);
   });

   //

   // Glossary popover bindings
   bindGlossaryPopovers();
});

// Page level js logic goes here.
export function initUnitNav() {
   $('#unitNav').on('click', '.unit-item', function () {
      $('.unit-item').removeClass('unit-active');
      $(this).addClass('unit-active');
      // Use raw attribute, not jQuery .data()
      const selector = this.getAttribute('data-target');
      if (!selector) {
         console.warn('Missing data-target attribute');
         return;
      }
      const targetEl = document.querySelector(selector);
      if (targetEl) {
         targetEl.scrollIntoView({ behavior: 'smooth' });
      } else {
         console.warn('No element found for selector:', selector);
      }
   });
}

function initTargetSRT() {
   const $targetInput = $('#srt-target');
   $('#srt-standard').prop('checked', true); // select 'General'
   $targetInput.val('0.35').prop('disabled', true);

   // Listen for toggle changes
   $('input[name="srt-mode"]').on('change', function () {
      const mode = this.value;

      if (mode === 'std') {
         $targetInput.val('0.35').prop('disabled', true);
      } else if (mode === 'danger') {
         $targetInput.val('0.40').prop('disabled', true);
      } else if (mode === 'user') {
         $targetInput.prop('disabled', false).focus();
      }

      triggerSRTCalculation(0); // always unit 0 for now
   });
}

/**
 * Attach a debounced handler to all input/select fields within an `.srt-unit-form`.
 * @param {Function} onChangeFn - The function to call after debounced change - onChangeFn($input, field);
 * @param {number} debounceDelay - Optional debounce time in ms (default: 400ms)
 */
export function bindSRTFormChangeHandler(onChange, debounceDelay = 400) {
   const $form = $('.srt-unit-form');
   if (!$form.length) {
      console.log('No .srt-unit-form found.');
      return;
   }

   const debounced = debounce(function (e) {
      const $input = $(e.target);
      const field = $input.data('field') || $input.attr('name') || $input.attr('id');
      const id = $input.attr('id') || '';

      // Match trailing dash-number: e.g. "f-roll-center-height-0" → 0
      const match = id.match(/-(\d+)$/);
      const unitIndex = match ? parseInt(match[1], 10) : 0; // if no unit associated with the field, default to 0

      onChange($input, field, unitIndex);
   }, debounceDelay);

   $form.find('input:not([disabled]), select:not([disabled])').each(function () {
      if ($(this).hasClass('no-auto-calc')) {
         return; // skip auto calc binding for this element
      }
      $(this).on('input', debounced);
      $(this).on('change', debounced);
   });

   // --- External control: #srt-target changes - also do calc ---
   const $srtTarget = $('#srt-target');
   if ($srtTarget.length) {
      $srtTarget.on('input change', debounced);
   }
}

function triggerSRTCalculation(unitIdx) {
   // Validate all fields and get data
   const { valid, data } = validateAllFields(unitIdx);
   if (!valid) {
      console.log('Form validation failed for unit .' + unitIdx);

      resetSummaryResultCard(unitIdx);
      renderMessageCard('error', unitIdx, 'Please fix the highlighted errors before calculating SRT.');
      showHideResults(unitIdx, false);
      $('html, body').animate({ scrollTop: $('.is-invalid').first().offset().top - 100 }, 300);
      return;
   }

   // Validate target SRT input
   const targetSRT = parseFloat($('#srt-target').val());
   if (isNaN(targetSRT) || targetSRT < 0.0 || targetSRT > 1.0) {
      console.error('Invalid target SRT value:', targetSRT);
      renderMessageCard('error', unitIdx, 'Invalid target SRT value. Please enter a number between 0.0 and 1.0.');
      showHideResults(unitIdx, false);
      return;
   }

   // Prepare data for SRT calculation
   const inputData = {
      ...data,
   };

   $(`results-messages-${unitIdx}`).empty().hide();

   $.ajax({
      url: '/api/srt-calc',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ unitIndex: unitIdx, inputs: inputData }),
      success: function (response) {
         const { unitIndex, srtResults } = response || {};
         currentSRT = srtResults?.srt ?? 0; // Store current SRT
         window.currentPayloadCog = srtResults?.payloadCgHeight ?? 0; // Store current payload CoG height

         const tw = srtResults?.trackWidths || {};
         frontTrackWidth = tw.front ?? 0; // Store front track width
         rearTrackWidth = tw.rear ?? 0; // Store rear track width
         renderResults(unitIndex, srtResults, targetSRT);
         updateDependentFields({
            unitIndex,
            frontTrackWidth,
            rearTrackWidth,
         });
      },
      error: function (xhr, status, error) {
         console.error('SRT calculation failed:', error);
         //alert('An error occurred while calculating SRT.');
      },
   });
}

export function initCharts(unitIndex) {
   // Initialize the graphs tab listener for unit 0
   setupGraphsTabListener(unitIndex, (idx) => {
      refreshSRTCharts(idx);
   });

   // Mode change in charts
   // attach another jQuery handler for mode switch for charts
   $('input[name="srt-boundary-mode"]').on('change', function () {
      refreshSRTCharts(unitIndex);
   });
}

/**
 * Fetch SRT sensitivity curve data from the backend and update charts
 */
function refreshSRTCharts(unitIdx) {
   const { valid, data } = validateAllFields(unitIdx);
   const targetSRT = parseFloat($('#srt-target').val());

   if (!valid || isNaN(targetSRT) || targetSRT < 0.0 || targetSRT > 1.0 || currentSRT <= 0) {
      console.log('Validation failed for charts, aborting refresh.');
      //console.log({ valid, targetSRT, currentSRT });
      return;
   }
   // Update charts
   refreshCogSRTChart(unitIdx, data, currentSRT, targetSRT);
   refreshPayloadSRTChart(unitIdx, data, currentSRT, targetSRT);
   refreshFeasibleBoundaryChart(unitIdx, data, targetSRT, window.currentPayloadCog);
}

function updateDependentFields(result) {
   // Update dependent form fields based on result
   const { unitIndex, frontTrackWidth, rearTrackWidth } = result;
   updateTrackWidthDisplay('f-', unitIndex, frontTrackWidth);
   updateTrackWidthDisplay('r-', unitIndex, rearTrackWidth);
}

export function bindGlossaryPopovers(scope = document) {
   $(scope)
      .find('[data-field]')
      .each(function () {
         const $input = $(this);
         const fieldKey = $input.data('field'); // e.g. "vehicleType" or "f-gross-mass"
         const entry = GLOSSARY[fieldKey];

         if (!entry) {
            console.log(`No glossary entry found for: ${fieldKey}`);
            return;
         }

         // Find label linked to this input (for/id association)
         const inputId = $input.attr('id');
         const $label = $(`label[for="${inputId}"]`);
         if ($label.length) {
            $label
               .addClass('glossary-label')
               .attr('tabindex', '0')
               .attr('role', 'button')
               .attr('data-bs-toggle', 'popover')
               .attr('data-bs-trigger', 'focus')
               .attr('data-bs-placement', 'top')
               .attr('data-bs-html', 'true')
               .attr('data-bs-title', entry.title || fieldKey)
               .attr('data-bs-content', entry.long || entry.short);

            new bootstrap.Popover($label[0]);
         }
      });
}
